module.exports = __webpack_public_path__ + "static/img/bg-pt.2aff9e4e.png";